import { ReactNode } from "react";

export type ActionRecordAudioType = {
  audio: HTMLAudioElement;
  blob: Blob;
  path: string;
};

export type BaseProviderType = {
  children: ReactNode;
};

export type BaseReponseType = {
  idReturnAPI: number;
  deReturnAPI: string;
  dtServer: string;
};

export enum ControlTypeEnum {
  Text = "AytyFramework.UI.ViewType.Controls.TextBox",
  MaskedText = "AytyFramework.UI.ViewType.Controls.MaskedTextBox",
  Button = "AytyFramework.UI.ViewType.Controls.Button",
  Select = "AytyFramework.UI.ViewType.Controls.ComboBoxDropDown",
}

export enum EnvironmentEnum {
  development = "development",
  test = "test",
  homolog = "homolog",
  production = "production",
}

export enum externalPathEnum {
  dashboardDetail = "/external/dashboard/metricsDetail",
  notepad = "/external/notepad",
  report = "/external/report",
  telemetry = "/external/telemetry",
  videoCall = "/external/videoCall",
}

export type LocationStateType = {
  from: {
    pathname: string;
    search: string;
    hash: string;
    key: string;
  };
};

export type ModalParamsType = {
  open: boolean;
  onClose: () => void;
};

export type OptionType<T> = {
  _id?: string;
  value: T;
  label: string;
};

export type PageXLSType = {
  name?: string;
  list: object[];
  head?: string[];
  footer?: string[];
};

export type PermissionProviderType = BaseProviderType & {
  hasPermission?: boolean;
};

export type RecordAudioType = {
  start: () => void;
  stop: () => Promise<ActionRecordAudioType>;
  finish: () => Promise<ActionRecordAudioType>;
};

export enum ReportEnum {
  call,
  detailedSales,
  hsmBatchDetail,
  interaction,
  interactionAndRecording,
  interactionMap,
  licenseAnalytic,
  licenseConsolidated,
  operationsPerformance,
  operationsPerformanceByOrder,
  order,
  overview,
  ticketAnalytic,
  ticketConsolidated,
  usersInRealTime,
}

export enum ServicePathEnum {
  getAttendances = "Omni/GetOmniListOnLine",
  getAgentAPI = "Omni/GetAgentAPI",
  finishAttendance = "Omni/FinishOmni",
  verifyFinishAuto = "Omni/VerifyFinishAutoOmniVoice",
}

export type SoftPhoneManagerType = {
  unmute: () => any;
  unhold: () => any;
  mute: () => any;
  hold: () => any;
};

export type StepItemType = {
  _id: string;
  title: string;
  children: ReactNode;
  to: string;
};

export type TelemetryErrorType = {
  status: number | string;
  message: string;
  path: string;
  response: string;
};

export * from "./attendance";
export * from "./campaign";
export * from "./channel";
export * from "./customTable";
export * from "./dashboard";
export * from "./faq";
export * from "./form";
export * from "./hsm";
export * from "./interval";
export * from "./list";
export * from "./order";
export * from "./permission";
export * from "./product";
export * from "./project";
export * from "./queue";
export * from "./quiz";
export * from "./report";
export * from "./status";
export * from "./ticket";
export * from "./user";
